/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ClassroomdisciplineQueryResponse,
  GetApiV1ClassroomdisciplineQueryParams,
  GetApiV1Classroomdiscipline401,
  GetApiV1Classroomdiscipline500,
} from "../../types/classPlanningController/GetApiV1Classroomdiscipline.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1Classroomdiscipline } from "../../clients/classPlanningController/getApiV1Classroomdiscipline.ts";

export const getApiV1ClassroomdisciplineQueryKey = (
  params?: GetApiV1ClassroomdisciplineQueryParams,
) =>
  [
    { url: "/api/v1/classroomdiscipline" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ClassroomdisciplineQueryKey = ReturnType<
  typeof getApiV1ClassroomdisciplineQueryKey
>;

export function getApiV1ClassroomdisciplineQueryOptions(
  params?: GetApiV1ClassroomdisciplineQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ClassroomdisciplineQueryKey(params);
  return queryOptions<
    GetApiV1ClassroomdisciplineQueryResponse,
    ResponseErrorConfig<
      GetApiV1Classroomdiscipline401 | GetApiV1Classroomdiscipline500
    >,
    GetApiV1ClassroomdisciplineQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1Classroomdiscipline(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Lista paginada com filtros por empresa, curso, turma, módulo, status, datas, disciplina, polo e professor. **(Requer Authorization para autenticação)**
 * @summary Listar planejamentos (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline}
 */
export function useGetApiV1Classroomdiscipline<
  TData = GetApiV1ClassroomdisciplineQueryResponse,
  TQueryData = GetApiV1ClassroomdisciplineQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ClassroomdisciplineQueryKey,
>(
  params?: GetApiV1ClassroomdisciplineQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ClassroomdisciplineQueryResponse,
        ResponseErrorConfig<
          GetApiV1Classroomdiscipline401 | GetApiV1Classroomdiscipline500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1ClassroomdisciplineQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ClassroomdisciplineQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1Classroomdiscipline401 | GetApiV1Classroomdiscipline500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
